/* Hero slideshow SP — ported from bundle variation-sport.jsx SportConfidence.
 * setSlide(i) toggles active slide; nav buttons + optional autoplay.
 * Idempotent per Regla 15 (re-runs on shopify:section:load without double-binding). */
(function () {
  function initHero(root) {
    if (!root || root.dataset.spBound === '1') return;
    root.dataset.spBound = '1';

    var viewport = root.querySelector('.sp-hero__viewport');
    var slides = Array.prototype.slice.call(root.querySelectorAll('.sp-hero__slide'));
    var navBtns = Array.prototype.slice.call(root.querySelectorAll('.sp-hero__navbtn'));
    if (slides.length === 0) return;

    var current = 0;
    var timer = null;
    var autoplay = root.dataset.autoplay === 'true';
    var speed = (parseInt(root.dataset.autoplaySpeed, 10) || 6) * 1000;

    function setSlide(i) {
      current = (i + slides.length) % slides.length;
      // Desplaza el track: la imagen actual sale y entra la siguiente (transición visible).
      if (viewport) viewport.style.transform = 'translateX(-' + (current * 100) + '%)';
      slides.forEach(function (s, idx) {
        var active = idx === current;
        s.classList.toggle('is-active', active);
        if (active) {
          s.removeAttribute('aria-hidden');
        } else {
          s.setAttribute('aria-hidden', 'true');
        }
        // sync nav buttons inside this slide (nav is duplicated per slide in markup)
        var btns = s.querySelectorAll('.sp-hero__navbtn');
        Array.prototype.forEach.call(btns, function (b) {
          b.classList.toggle('is-active', parseInt(b.dataset.goto, 10) === current);
        });
      });
    }

    function bindNav(btns) {
      btns.forEach(function (btn) {
        if (btn.dataset.spBound === '1') return;
        btn.dataset.spBound = '1';
        btn.addEventListener('click', function () {
          setSlide(parseInt(btn.dataset.goto, 10) || 0);
          restart();
        });
      });
    }

    function restart() {
      if (timer) clearInterval(timer);
      if (autoplay && slides.length > 1) {
        timer = setInterval(function () {
          setSlide(current + 1);
        }, speed);
      }
    }

    bindNav(navBtns);
    setSlide(0);
    restart();

    // Swipe táctil (móvil): arrastrar con el dedo cambia de slide
    if (slides.length > 1) {
      var vp = root.querySelector('.sp-hero__viewport') || root;
      var sx = null, sy = null;
      vp.addEventListener('touchstart', function (e) {
        var t = e.touches[0]; sx = t.clientX; sy = t.clientY;
      }, { passive: true });
      vp.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var t = e.changedTouches[0];
        var dx = t.clientX - sx, dy = t.clientY - sy;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) {
          setSlide(current + (dx < 0 ? 1 : -1));
          restart();
        }
        sx = null; sy = null;
      }, { passive: true });
    }

    // pause autoplay on hover (desktop)
    root.addEventListener('mouseenter', function () {
      if (timer) clearInterval(timer);
    });
    root.addEventListener('mouseleave', restart);
  }

  function initAll() {
    document.querySelectorAll('sp-hero').forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor: re-init the reloaded section (idempotent guard prevents dupes)
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('sp-hero');
    if (root) {
      root.dataset.spBound = '';
      initHero(root);
    }
  });
})();
